import { gatewayGetRequest } from '@/api/clients/gatewayAxios';

export const getGatewayImageFetch = async (fileName: string) => {
  const response = await gatewayGetRequest<Blob>(`image/fetch?filename=${encodeURIComponent(fileName)}`, {
    responseType: 'blob',
  });
  return response.data;
};
